import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { OS_NAMES } from "modules/systemCheck/constants";
import { DetectionTestBase } from "../DetectionTestBase";

interface Props {
  os: OS_NAMES;
  isSupported: boolean;
  hasDivider?: boolean;
}

export const OperatingSystemDetection = ({
  os,
  isSupported,
  hasDivider = true,
}: Props): JSX.Element => {
  const { t } = useI18n(["common", "micCamCheck", "url"]);

  return (
    <DetectionTestBase
      testName={` ${
        isSupported
          ? t("micCamCheck:operating.system")
          : t("micCamCheck:os.unsupported")
      }`}
      testResult={
        <Typography variant="body1">
          {t(
            isSupported
              ? "micCamCheck:operating.system.supported"
              : "micCamCheck:os.unsupported.message",
            {
              os,
            },
          )}
        </Typography>
      }
      troubleShootLink={t("url:supported.os.browsers")}
      showTroubleshootLink={!isSupported}
      isRecommendation
      hasDivider={hasDivider}
    />
  );
};
